exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item{cursor:pointer}.skeleton-line{height:14px;width:100%;background:linear-gradient(90deg,#eee 25%,#ddd 37%,#eee 63%);background-size:400% 100%;animation:skeleton-loading 1.4s ease infinite;border-radius:4px}@keyframes skeleton-loading{0%{background-position:100% 0}to{background-position:0 0}}.text-muted i{color:#999}.compact-table td,.compact-table th{padding:4px 6px!important;font-size:12px}.compact-table th{white-space:normal;line-height:1.2}.compact-table td.text-right{font-size:12px}.table tbody tr td:last-child,.table thead tr th:last-child{padding-right:.5rem!important}", ""]);

// exports
